import React from 'react';

import { Start } from '@mui/icons-material';
import { Drawer, IconButton, Toolbar, useTheme } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import AttendancesDetailPage from './page';

const AttendanceDetailLayout = () => {
  const theme = useTheme();

  const { id: attendanceId } = useParams();
  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);

  const onDrawerCloseHandler = React.useCallback(() => {
    setOpen(false);
    navigate('/attendances', { replace: true });
  }, [navigate]);

  React.useEffect(() => {
    let timeoutId: string | number | NodeJS.Timeout | undefined;
    if (attendanceId) {
      // Wait for React Route changing route to play open animation
      timeoutId = setTimeout(() => setOpen(true), 10);
    } else {
      onDrawerCloseHandler();
    }

    return () => clearTimeout(timeoutId);
  }, [attendanceId, onDrawerCloseHandler]);

  return (
    <Drawer
      open={open}
      anchor="right"
      variant="persistent"
      PaperProps={{
        variant: 'outlined',
        sx: { width: '100%', maxWidth: theme.breakpoints.values.sm },
      }}
    >
      <Toolbar>
        <IconButton size="large" edge="start" color="inherit" onClick={onDrawerCloseHandler}>
          <Start />
        </IconButton>
        <div style={{ flex: 1 }} />
      </Toolbar>

      <AttendancesDetailPage />
    </Drawer>
  );
};

export default AttendanceDetailLayout;
